// Pin clásico de Leaflet (punta abajo) con el token primary, compartido por
// los mapas del frontend (picker de ubicación, mapa de pagos, "Ver en
// mapa"): evita depender de las imágenes default del bundler y duplicar el
// HTML del icono en cada componente.
export const PIN_WHITE = '#fff';
export const PIN_SHADOW = '0 0 0 1.5px rgba(0,0,0,0.35), 0 1px 4px rgba(0,0,0,0.5)';
export const PIN_SIZE: [number, number] = [24, 36];
export const PIN_ANCHOR: [number, number] = [12, 36];

export function pinHtml(primary: string): string {
  return `
    <div style="
      position: relative; width: ${PIN_SIZE[0]}px; height: ${PIN_SIZE[1]}px;
      border-radius: 50% 50% 50% 0; transform: rotate(-45deg);
      background: ${primary};
      border: 2px solid ${PIN_WHITE}; box-shadow: ${PIN_SHADOW};
      display: flex; align-items: center; justify-content: center;
    ">
      <span style="
        width: 6px; height: 6px; border-radius: 50%;
        background: ${PIN_WHITE}; transform: rotate(45deg);
      "></span>
    </div>`;
}
